import React, { useState } from 'react';
import CustomSwitch from '../custom/CustomSwitch';

export const PERMISOS_ROL_STYLES = `
    .permisos-rol-card .card-header .card-title {
        font-size: 1.25rem;
        font-weight: 700;
    }
    .permisos-rol-section-title {
        font-size: 1.125rem !important;
        font-weight: 700 !important;
        line-height: 1.35;
    }
    .permisos-rol-section-title .section-icon {
        font-size: 1.15rem;
    }
    .permission-item {
        background: white;
        transition: all 0.2s ease;
        cursor: pointer;
        min-height: 45px;
    }
    .permission-item:hover {
        background: #e3f2fd;
        border-color: #2196f3 !important;
    }
    .permission-label {
        color: #495057;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 500;
    }
    .permisos-rol-check-label {
        font-size: 0.95rem;
    }
    .permisos-rol-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .permisos-rol-scroll::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    .permisos-rol-scroll::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }
    .permisos-rol-scroll::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;

function PermisoSeccionAcordeon({
    sectionKey,
    title,
    icon,
    titleStyle,
    permissions,
    selectedIds,
    onTogglePermission,
    onToggleSection,
    areAllSectionSelected,
    selectAllId,
    isOpen,
    onToggleOpen,
    footer,
}) {
    if (!permissions || permissions.length === 0) {
        return null;
    }

    return (
        <div className="card mb-3">
            <div className="card-header py-2">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h4 className="card-title mb-0 flex-grow-1 permisos-rol-section-title">
                        <button
                            type="button"
                            className="btn btn-link d-block w-100 text-left p-0 permisos-rol-section-title"
                            onClick={onToggleOpen}
                            aria-expanded={isOpen}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <i className={`${icon} mr-2 section-icon`} style={titleStyle}></i>
                            {title}
                            <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} float-right mt-1 text-muted`} style={{ fontSize: '0.9rem' }}></i>
                        </button>
                    </h4>
                    <div
                        className="form-check mb-0 ml-2 flex-shrink-0"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={selectAllId}
                            checked={areAllSectionSelected(permissions)}
                            onChange={() => onToggleSection(permissions)}
                        />
                        <label className="form-check-label text-muted permisos-rol-check-label" htmlFor={selectAllId}>
                            Marcar todos
                        </label>
                    </div>
                </div>
            </div>
            <div className={`collapse ${isOpen ? 'show' : ''}`}>
                <div className="card-body pt-2 pb-3">
                    <div className="permission-list">
                        {permissions.map((permission) => (
                            <div
                                key={permission.id}
                                className="permission-item d-flex justify-content-between align-items-center py-2 px-3 mb-2 border rounded"
                            >
                                <label
                                    className="mb-0 permission-label"
                                >
                                    {permission.name}
                                </label>
                                <CustomSwitch
                                    checked={selectedIds.includes(permission.id)}
                                    onChange={() => onTogglePermission(permission.id)}
                                />
                            </div>
                        ))}
                    </div>
                    {footer}
                </div>
            </div>
        </div>
    );
}

function PermisosRolAcordeones({
    idPrefix,
    sections,
    selectedIds,
    onTogglePermission,
    onToggleSection,
    areAllSectionSelected,
    onToggleAllGlobal,
    areAllGlobalSelected,
}) {
    const [acordeonesAbiertos, setAcordeonesAbiertos] = useState(() => {
        const initial = {};
        let firstKey = null;
        sections.forEach((section) => {
            if (section.permissions?.length > 0 && firstKey === null) {
                firstKey = section.key;
            }
        });
        sections.forEach((section) => {
            initial[section.key] = section.key === firstKey;
        });
        return initial;
    });

    const toggleAcordeon = (key) => {
        setAcordeonesAbiertos((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const renderSections = () =>
        sections.map((section) => (
            <PermisoSeccionAcordeon
                key={section.key}
                sectionKey={section.key}
                title={section.title}
                icon={section.icon}
                titleStyle={section.titleStyle}
                permissions={section.permissions}
                selectedIds={selectedIds}
                onTogglePermission={onTogglePermission}
                onToggleSection={onToggleSection}
                areAllSectionSelected={areAllSectionSelected}
                selectAllId={`${idPrefix}-${section.selectAllId}`}
                isOpen={!!acordeonesAbiertos[section.key]}
                onToggleOpen={() => toggleAcordeon(section.key)}
                footer={section.footer}
            />
        ));

    return (
        <div className="card permisos-rol-card">
            <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="card-title mb-0">
                    <i className="fas fa-shield-alt mr-2"></i>
                    Configuración de Permisos
                </h3>
                <div className="form-check mb-0">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`${idPrefix}-selectAllGlobal`}
                        checked={areAllGlobalSelected()}
                        onChange={onToggleAllGlobal}
                    />
                    <label className="form-check-label font-weight-bold permisos-rol-check-label" htmlFor={`${idPrefix}-selectAllGlobal`}>
                        Marcar todos los permisos
                    </label>
                </div>
            </div>
            <div
                className="card-body permisos-rol-scroll"
                style={{ maxHeight: '70vh', overflowY: 'auto', minHeight: '400px' }}
            >
                {renderSections()}
            </div>
        </div>
    );
}

export default PermisosRolAcordeones;
